import React from 'react';
import { Calendar, DateObject } from 'react-multi-date-picker';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import { DATE_FORMAT } from './helper';

interface Props {
  value: string[];
  onChange: (newValues: string[]) => void;
  multiple?: boolean;
  startDate?: string;
  occurrences: string[];
  availabilities: string[];
  unavailabilities: string[];
  availabilityRestrictionDays?: number | null;
}

export function DateSelect({
  value,
  onChange,
  multiple,
  startDate,
  occurrences,
  availabilities,
  unavailabilities,
  availabilityRestrictionDays,
}: Props) {
  const calendarValue = (() => {
    if (!value) {
      return [];
    }
    return value.map((datum) => new DateObject({ date: datum, format: DATE_FORMAT }));
  })();

  const minDate = startDate ? new DateObject({ date: startDate, format: DATE_FORMAT }) : new DateObject();

  // Calculate max date based on availability restriction
  const maxDate = availabilityRestrictionDays ? new DateObject().add(availabilityRestrictionDays, 'days') : undefined;

  return (
    <Calendar
      multiple={multiple}
      format={'DD MMM YY'}
      mapDays={({ date }) => {
        const dateStr = date.format(DATE_FORMAT);
        let style = {} as React.CSSProperties;

        if (availabilities.includes(dateStr)) {
          style = {
            backgroundColor: '#0374D533',
            color: '#8899AC',
          };
        }

        if (unavailabilities.includes(dateStr)) {
          style = {
            backgroundColor: '#788B9D40',
            color: '#8899AC',
          };
        }

        // Check if date is beyond restriction window
        const isBeyondRestriction = maxDate ? date.toDate() > maxDate.toDate() : false;

        if (isBeyondRestriction) {
          style = {
            ...style,
            opacity: 0.4,
          };
        }

        const disabled =
          !occurrences.includes(dateStr) ||
          availabilities.includes(dateStr) ||
          unavailabilities.includes(dateStr) ||
          isBeyondRestriction;

        return {
          disabled,
          style,
        };
      }}
      currentDate={calendarValue[0]}
      minDate={minDate}
      maxDate={maxDate}
      value={calendarValue}
      onChange={(selectDates: DateObject[]) => {
        onChange(selectDates?.map((selectDate) => selectDate.format(DATE_FORMAT)));
      }}
      className='multi-date-picker'
      plugins={[<DatePanel position='right' sort='date' />]}
    />
  );
}
